import { DataFileInterface } from '@systemeio/file-manager'
import { DonwloadIcon, Tooltip } from '@systemeio/ui'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { BinIcon, CheckCircleIcon } from '@systemeio/ui'

export type FileListItemType = {
  file: Pick<DataFileInterface, 'id' | 'name' | 'filename' | 'path'>
  progress?: number
  disabled?: boolean
  uploaded?: boolean
}

export const FileListItem = ({
  file,
  progress,
  disabled,
  uploaded,
  onDelete,
}: FileListItemType & {
  onDelete: () => void
}) => {
  const { t } = useLocoTranslation()

  return (
    <div className="flex flex-row gap-2 break-all">
      {progress !== undefined && <span className={'text-text-tertiary text-sm'}>{progress}%</span>}

      {uploaded && <CheckCircleIcon className={'fill-green h-[16px] w-[16px]'} />}

      {file.name}

      <Tooltip
        className="shrink-0"
        wrapperClassName="h-[16px] w-[16px] self-center"
        mode={'hover'}
        label={t('global.download')}
        disabled={disabled}
      >
        <a target={'_blank'} rel={'noreferrer'} href={file.path} className={'group outline-hidden'}>
          <DonwloadIcon
            className={twMerge(
              'main-transition-colors h-[16px] w-[16px]',
              disabled
                ? 'cursor-default'
                : 'group-hover:fill-brand-primary group-focus-visible:fill-brand-primary',
            )}
          />
        </a>
      </Tooltip>

      <Tooltip
        className="shrink-0"
        wrapperClassName="h-[16px] w-[16px] self-center"
        mode={'hover'}
        label={t('global.delete')}
        disabled={disabled}
      >
        <button disabled={disabled} onClick={() => onDelete()} className={'group outline-hidden'}>
          <BinIcon
            className={`
                main-transition-colors h-[16px] w-[16px]
                ${twMerge(
                  disabled
                    ? 'cursor-default'
                    : 'group-hover:fill-danger group-focus-visible:fill-danger ',
                )}`}
          />
        </button>
      </Tooltip>
    </div>
  )
}
